import { useContext, useRef } from "react";
import { createPortal } from "react-dom";
import { editTab } from "../CommonFunc";
import "./EditTab.scss";
import { AppContext } from "../../Context/AppContext";
function EditTab(props) {
	const { theme } = useContext(AppContext);
	const inputRef = useRef();
	const hadleCreate = () => {
		editTab(props.currentDiary?.ID, inputRef.current.value).then((result) => {
			props.refreshMenuList(false);
		});
		props.setOpenEditTab(false);
		window.addDiaryFlag = true;
	};
	return createPortal(
		<div
			className='edit-tab-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${18 * theme.fontMultiplier}px`,
			}}
		>
			<div className='edit-tab-dialog'>
				<input
					ref={inputRef}
					className='name-field'
					type='text'
					placeholder='Имя дневника'
					defaultValue={props.currentDiary?.TAB_MNEMO}
					autoFocus
				/>
				<div className='create-button' onClick={() => hadleCreate()}>
					Переименовать
				</div>
				<div
					className='close-button'
					onClick={() => props.setOpenEditTab(false)}
				>
					Закрыть
				</div>
			</div>
		</div>,
		document.getElementById("tabActions")
	);
}

export default EditTab;
